import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getTuitionFeePaginationAction } from "../../redux/actions/tuitionFeeActions";
import {
  TUITION_FEE_ALL_ACTIONS_TYPE,
  TUITION_FEE_MODAL_ACTION_TYPE,
} from "../../redux/actions-type";
import TuitionFeeData from "./components/TuitionFeeData";
import GlobalHead from "../../globalComponents/GlobalHead/GlobalHead";
import HeadTabs from "../../globalComponents/HeadTabs/HeadTabs";
import { useLocation } from "react-router-dom";

const TuitionFeePage = ({ type }) => {
  const dispatch = useDispatch();
  const { loading, currentLength } = useSelector(
    (state) => state.tuitionFeePagination,
  );
  const { tuitionFeeSearchValues } = useSelector((state) => state.searchValues);
  const { selectedGroups, selectedCourses } = useSelector(
    (state) => state.selectedGroups,
  );
  const { tuitionStatus } = useSelector((state) => state.filter);

  const filterTuition = () => {
    dispatch({
      type: TUITION_FEE_ALL_ACTIONS_TYPE.RESET_TUITION_FEE_PAGINATION,
    });

    dispatch(
      getTuitionFeePaginationAction(
        0,
        tuitionFeeSearchValues,
        selectedCourses,
        selectedGroups,
        tuitionStatus,
        type,
      ),
    );
  };

  const getNextTuitionFees = () => {
    if (loading) return;

    if (tuitionFeeSearchValues) {
      dispatch(
        getTuitionFeePaginationAction(
          currentLength,
          tuitionFeeSearchValues,
          selectedCourses,
          selectedGroups,
          tuitionStatus,
          type,
        ),
      );
    } else {
      dispatch(
        getTuitionFeePaginationAction(
          currentLength,
          "",
          selectedCourses,
          selectedGroups,
          tuitionStatus,
          type,
        ),
      );
    }
  };

  const openModal = () => {
    dispatch({
      type: TUITION_FEE_MODAL_ACTION_TYPE.GET_TUITION_FEE_MODAL,
      payload: { data: {}, openModal: true },
    });
  };

  const searchData = (e) => {
    e.preventDefault();

    dispatch({
      type: TUITION_FEE_ALL_ACTIONS_TYPE.RESET_TUITION_FEE_PAGINATION,
    });

    dispatch(
      getTuitionFeePaginationAction(
        0,
        tuitionFeeSearchValues,
        selectedCourses,
        selectedGroups,
        tuitionStatus,
        type,
      ),
    );
  };

  useEffect(() => {
    // console.log(type, " MOUNT OLDU");
    dispatch({
      type: TUITION_FEE_ALL_ACTIONS_TYPE.RESET_TUITION_FEE_PAGINATION,
    });

    dispatch({
      type: TUITION_FEE_MODAL_ACTION_TYPE.CLOSE_CONFIRM_MODAL,
    });

    if (tuitionFeeSearchValues) {
      dispatch(
        getTuitionFeePaginationAction(
          0,
          tuitionFeeSearchValues,
          "",
          "",
          tuitionStatus,
          type,
        ),
      );
    } else {
      dispatch(
        getTuitionFeePaginationAction(0, "", "", "", tuitionStatus, type),
      );
    }

    return () => {
      dispatch({
        type: TUITION_FEE_ALL_ACTIONS_TYPE.RESET_TUITION_FEE_PAGINATION,
      });

      dispatch({
        type: TUITION_FEE_MODAL_ACTION_TYPE.CLOSE_CONFIRM_MODAL,
      });
    };
  }, [type]);

  return (
    <div className="details-page tuition-fee-page">
      <GlobalHead
        searchData={searchData}
        openModal={openModal}
        filter={filterTuition}
        addBtn={false}
        DATA_SEARCH_VALUE={"TUITION_FEE_SEARCH_VALUE"}
        dataSearchValues={tuitionFeeSearchValues}
        profile={"tuitionFee"}
        statusType="tutionFee"
      />

      <HeadTabs
        firstRoute={"/tuition-fee"}
        secondRoute={"/tuition-fee/company"}
        firstPathname={"Tələbələr"}
        secondPathname={"Şirkətlər"}
      />

      <TuitionFeeData
        key={type}
        getNextTuitionFees={getNextTuitionFees}
        type={type}
      />
    </div>
  );
};

export default TuitionFeePage;
